import React, { useEffect, useReducer } from 'react';
import styles from './JackpotCasino.scss';
import cn from 'classnames';

// MANAGERS
import { TJackpotCasinoLevelItem } from '@GFTypes/index';
import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';

const JackpotCasinoLevelItem: React.FC<{ data: TJackpotCasinoLevelItem; growthTrend?: { show: boolean; value: number } }> = ({
    data,
    growthTrend = { show: false, number: 0 }
}) => {
    useEffect(() => {});

    return (
        <div className={styles.jackpot_casino_states_level}>
            {data.levelName}: {CurrencyUtils.formatRawCurrencyValue(data.currentValue)}
            {growthTrend.show && (
                <>
                    {data.currentValue > growthTrend.value && <div className={cn(styles.growth_trend_icon, styles.growth_trend_icon_up)}></div>}
                    {data.currentValue === growthTrend.value && <div className={styles.growth_trend_icon}>---</div>}
                    {data.currentValue < growthTrend.value && <div className={cn(styles.growth_trend_icon, styles.growth_trend_icon_down)}></div>}
                </>
            )}
        </div>
    );
};

export default JackpotCasinoLevelItem;
